export const GET_SADDLE_DETAIL_QUERY = /* GraphQL */ `
  query SaddleDetailQuery($id: ID!, $horseId: ID, $brandName: String) {
    listSaddleDetail(id: $id, horseId: $horseId, brandName: $brandName) {
      brandName
      variantId
      createdAt
      description
      discipline
      gallery
      newOrUsed
      photo
      pk
      price
      productTitle
      quantity
      score
      size
      color
      availableColors
      sk
      status
      type
      updatedAt
      userId
      manufacturerMeasurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      measurements {
        barAngle
        gulletHeight
        gulletWidth
      }
    }
  }
`;

